export default __webpack_public_path__ + "static/media/Porque-NearshorIT-EN.d6cf2812.jpg";